import { render, staticRenderFns } from "./PDisplayPrice.vue?vue&type=template&id=0e5ed431"
import script from "./PDisplayPrice.vue?vue&type=script&lang=js"
export * from "./PDisplayPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports